import { useContext } from 'react';

import SemenPullContext from './SemenPullContext';

export function useSemenPullContext() {
  const context = useContext(SemenPullContext);

  if (!context) {
    throw new Error(
      'SemenPull.* component must be rendered as child of SemenPull component',
    );
  }

  return context;
}
